<template>
    <div>
        <div>
            <SignInPC v-if="isPC" />
            <SignInH5 v-else />
            <!-- <SignInH5New v-else :isBView="isBView"/> -->
        </div>
    </div>
</template>
<script>
    import { enableAppShare } from '../../../common/js/APP/share';
    import SignInH5 from '../components/SignInH5';
    import SignInH5New from '../components/SignInH5New';
    import SignInPC from '../components/SignInPC';
    import { getCookie, setCookie } from '../../../uitl/getParam.js';
    import { fetchQueryFNNew } from '@/service/api'
    export default {
        name: 'Index',
        components: {
            // SignInH5New,
            SignInH5,
            SignInPC,
        },
        data() {
            return {
                isBView:'A',//A版 false     B版 true
            };
        },
        created () {
            enableAppShare({
                title: '拉勾求职帮帮团，帮你内推“走后门”！',
                desc: '求职问题一站搞定',
                imgUrl: 'https://s20.lgstatic.com/growth/activity/20220215/1644912610561.png'
            });
            // this.getPageFn();
        },
        methods: {
            getPageFn() {
                const page_key = 'INTERPOLATE';
                if (!this.isApp) {
                    let page = JSON.parse(getCookie(page_key));
                    if (!page) {
                        page = {}
                        page.pageType = Math.ceil(Math.random() * 2)
                        setCookie(page_key, JSON.stringify(page))
                    }
                    this.isBView = page.pageType == 2 ? 'B' : 'A';
                    return
                }
                let params = {
                    pageMark: page_key,
                }
                fetchQueryFNNew(params).then(res => {
                    if(res.state == 1) {
                        if(res.content) { //命中页面 不返回值
                            this.isBView = 'B';
                        } else { //未命中 走a版
                            this.isBView = 'A'
                        }
                    } else {
                        this.isBView = 'A'  //默认a版  报错a版
                    }
                }).catch(error => {
                    this.isBView = 'A'  //默认a版  报错a版
                });
            },
        },
    };
</script>